var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrhIconSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "activity",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "22 12 18 12 15 21 9 3 6 12 2 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "airplay",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12 15 17 21 7 21 12 15"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "alert-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "alert-octagon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "alert-triangle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "align-center",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 6,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "align-justify",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10,
    x2: 3,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 3,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "align-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 10,
    x2: 3,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 18,
    x2: 3,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "align-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10,
    x2: 7,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 7,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "anchor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12H2a10 10 0 0 0 20 0h-3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "aperture",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 8,
    x2: 20.05,
    y2: 17.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 8,
    x2: 21.17,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.38,
    y1: 12,
    x2: 13.12,
    y2: 2.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 16,
    x2: 3.95,
    y2: 6.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 16,
    x2: 2.83,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.62,
    y1: 12,
    x2: 10.88,
    y2: 21.94
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "archive",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "21 8 21 21 3 21 3 8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 22,
    height: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 12 12 16 16 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 17 7 17 7 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 7 17 17 7 17"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 12 12 19 5 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 8 8 12 12 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 8,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 19 5 12 12 5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 16 16 12 12 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 5 19 12 12 19"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 12 12 8 8 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 8
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 17 7 7 17 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 17,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 7 17 7 17 17"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 12 12 5 19 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "at-sign",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "award",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bar-chart-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bar-chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "battery-charging",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 13,
    x2: 23,
    y2: 11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11 6 7 12 13 12 9 18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "battery",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 18,
    height: 12,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 13,
    x2: 23,
    y2: 11
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bell-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.73 21a2 2 0 0 1-3.46 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.63 13A17.89 17.89 0 0 1 18 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8a6 6 0 0 0-9.33-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.73 21a2 2 0 0 1-3.46 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bluetooth",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "book-open",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "book",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "box",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2.32 6.16 12 11 21.68 6.16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22.76,
    x2: 12,
    y2: 11
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "briefcase",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 14,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "camera-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "camera",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 4
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cast",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 20,
    x2: 2,
    y2: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22 4 12 14.01 9 11.01"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check-square",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 11 12 14 22 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15 18 9 12 15 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 18 15 12 9 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "18 15 12 9 6 15"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevrons-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "7 13 12 18 17 13"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 6 12 11 17 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevrons-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "11 17 6 12 11 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18 17 13 12 18 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevrons-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "13 17 18 12 13 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6 17 11 12 6 7"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevrons-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "17 11 12 6 7 11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 18 12 13 7 18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chrome",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.17,
    y1: 8,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.95,
    y1: 6.06,
    x2: 8.54,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.88,
    y1: 21.94,
    x2: 15.46,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "clipboard",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 4,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 6 12 12 16 14"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cloud-drizzle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 19,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 19,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cloud-lightning",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 11 9 17 15 17 11 23"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cloud-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cloud-rain",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cloud-snow",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "code",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16 18 22 12 16 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 6 2 12 8 18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "codepen",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22 8.5 12 15.5 2 8.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2 15.5 12 8.5 22 15.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 8.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "coffee",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8h1a4 4 0 0 1 0 8h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 1,
    x2: 6,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 1,
    x2: 14,
    y2: 4
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "command",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "compass",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 13,
    height: 13,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-down-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 10 4 15 9 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v7a4 4 0 0 1-4 4H4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-down-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15 10 20 15 15 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v7a4 4 0 0 0 4 4h12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-left-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "14 15 9 20 4 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4h-7a4 4 0 0 0-4 4v12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-left-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "14 9 9 4 4 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-7a4 4 0 0 1-4-4V4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-right-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "10 15 15 20 20 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h7a4 4 0 0 1 4 4v12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-right-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "10 9 15 4 20 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h7a4 4 0 0 0 4-4V4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-up-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 14 4 9 9 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v-7a4 4 0 0 0-4-4H4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-up-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15 14 20 9 15 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-7a4 4 0 0 1 4-4h12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cpu",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 1,
    x2: 15,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 20,
    x2: 9,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 20,
    x2: 15,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 9,
    x2: 23,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 14,
    x2: 23,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 9,
    x2: 4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14,
    x2: 4,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "credit-card",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 16,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 10,
    x2: 23,
    y2: 10
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "crop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13 1L6 16a2 2 0 0 0 2 2h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.13L16 6a2 2 0 0 1 2 2v15"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "crosshair",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 12,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 2,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "database",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5,
    rx: 9,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "delete",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 18,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "disc",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "dollar-sign",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "download-cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "8 17 12 21 16 17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "droplet",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit-3",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "external-link",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 3 21 3 21 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 21,
    y2: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "eye-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "fast-forward",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "13 19 22 12 13 5 13 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2 19 11 12 2 5 2 19"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "feather",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 2,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 15,
    x2: 9,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "figma",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "file-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "file-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "file-text",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 8,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 8,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 9 9 9 8 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "file",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 2 13 9 20 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "film",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2.18,
    ry: 2.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 2,
    x2: 7,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 2,
    x2: 17,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 17,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 22,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 22,
    y2: 7
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "flag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 22,
    x2: 4,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "folder-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "folder-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "folder",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "frown",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16s-1.5-2-4-2-4 2-4 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gift",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 12 20 22 4 22 4 12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "git-branch",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 3,
    x2: 6,
    y2: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a9 9 0 0 1-9 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "git-commit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.05,
    y1: 12,
    x2: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.01,
    y1: 12,
    x2: 22.96,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "git-merge",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21V9a9 9 0 0 0 9 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "git-pull-request",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6h3a2 2 0 0 1 2 2v7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 6,
    y2: 21
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "github",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gitlab",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "globe",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "grid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 7,
    height: 7
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hard-drive",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 12,
    x2: 2,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 16,
    x2: 6,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hash",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 20,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 3,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 14,
    y2: 21
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "headphones",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18v-6a9 9 0 0 1 18 0v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "heart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "help-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 22 9 12 15 12 15 22"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "image",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21 15 16 10 5 21"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "inbox",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "22 12 16 12 14 15 10 15 8 12 2 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "info",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "instagram",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 6.5,
    x2: 17.5,
    y2: 6.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "italic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 4,
    x2: 10,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 5,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 4,
    x2: 9,
    y2: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "key",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "layers",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 2 7 12 12 22 7 12 2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2 17 12 22 22 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2 12 12 17 22 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "layout",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 21,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 21,
    x2: 9,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "life-buoy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 9.17,
    y2: 9.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 14.83,
    x2: 19.07,
    y2: 19.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 9.17,
    x2: 19.07,
    y2: 4.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 9.17,
    x2: 18.36,
    y2: 5.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 19.07,
    x2: 9.17,
    y2: 14.83
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "link-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "link",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "linkedin",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "list",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18,
    x2: 21,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 3,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "loader",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 7.76,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 16.24,
    x2: 19.07,
    y2: 19.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 6,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 19.07,
    x2: 7.76,
    y2: 16.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 7.76,
    x2: 19.07,
    y2: 4.93
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 11,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "log-in",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 17 15 12 10 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 3,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "log-out",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 17 21 12 16 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 9,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22,6 12,13 2,6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "map-pin",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "map",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 16,
    y2: 22
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "maximize-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15 3 21 3 21 9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 21 3 21 3 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 3,
    x2: 14,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 10,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "maximize",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "meh",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "menu",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 21,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "message-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "message-square",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mic-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23,
    x2: 16,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10v2a7 7 0 0 1-14 0v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23,
    x2: 16,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minimize-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "4 14 10 14 10 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 10 14 10 14 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 10,
    y2: 14
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minimize",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minus-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minus-square",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "monitor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 14,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "moon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "more-horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "more-vertical",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mouse-pointer",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13l6 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "move",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "5 9 2 12 5 15"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 5 12 2 15 5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 19 12 22 9 19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 9 22 12 19 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "music",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18V5l12-2v13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "navigation-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 19 21 12 17 5 21 12 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "navigation",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3 11 22 2 13 21 11 13 3 11"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "octagon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "package",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2.32 6.16 12 11 21.68 6.16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22.76,
    x2: 12,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3.5,
    x2: 17,
    y2: 8.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "paperclip",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pause-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 15,
    x2: 10,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 15,
    x2: 14,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pause",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 4,
    height: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pen-tool",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19l7-7 3 3-7 7-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2l7.586 7.586"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "percent",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 5,
    y2: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 2.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-call",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-forwarded",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "19 1 23 5 19 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 23,
    y2: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-incoming",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16 2 16 8 22 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 16,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-missed",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 17,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 1,
    x2: 23,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 1,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone-outgoing",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "23 7 23 1 17 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 23,
    y2: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pie-chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.21 15.89A10 10 0 1 1 8 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12A10 10 0 0 0 12 2v10z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "play-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10 8 16 12 10 16 10 8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5 3 19 12 5 21 5 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus-square",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "pocket",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 10 12 14 16 10"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "power",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.64a9 9 0 1 1-12.73 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "printer",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 6 2 18 2 18 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 12,
    height: 8
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "radio",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "refresh-ccw",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 4 1 10 7 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23 20 23 14 17 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "refresh-cw",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1 20 1 14 7 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "repeat",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "17 1 21 5 17 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11V9a4 4 0 0 1 4-4h14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 23 3 19 7 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13v2a4 4 0 0 1-4 4H3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rewind",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11 19 2 12 11 5 11 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22 19 13 12 22 5 22 19"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rotate-ccw",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 4 1 10 7 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rotate-cw",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rss",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 11a9 9 0 0 1 9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a16 16 0 0 1 16 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "save",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 21 17 13 7 13 7 21"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 3 7 8 15 8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "scissors",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 8.12,
    y2: 15.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.47,
    y1: 14.48,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.12,
    y1: 8.12,
    x2: 12,
    y2: 12
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 16.65,
    y2: 16.65
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "send",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 2,
    x2: 11,
    y2: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22 2 15 22 11 13 2 9 22 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "server",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 8,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 20,
    height: 8,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "share-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.59,
    y1: 13.51,
    x2: 15.42,
    y2: 17.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.41,
    y1: 6.51,
    x2: 8.59,
    y2: 10.49
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 6 12 2 8 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "shield-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "shield",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-bag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10a4 4 0 0 1-8 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-cart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "shuffle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16 3 21 3 21 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21 16 21 21 16 21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 9,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sidebar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 21
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "skip-back",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "19 20 9 12 19 4 19 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 19,
    x2: 5,
    y2: 5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "skip-forward",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5 4 15 12 5 20 5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 19
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "slack",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "slash",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 19.07,
    y2: 19.07
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sliders",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 21,
    x2: 4,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 21,
    x2: 20,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14,
    x2: 7,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 16,
    x2: 23,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "smartphone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 14,
    height: 20,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "smile",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "speaker",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 20,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 6
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "square",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "stop-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sun",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 4.22,
    x2: 5.64,
    y2: 5.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 18.36,
    x2: 19.78,
    y2: 19.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 23,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 19.78,
    x2: 5.64,
    y2: 18.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 5.64,
    x2: 19.78,
    y2: 4.22
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sunrise",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 18a5 5 0 0 0-10 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 10.22,
    x2: 5.64,
    y2: 11.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 3,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 23,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 11.64,
    x2: 19.78,
    y2: 10.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 22,
    x2: 1,
    y2: 22
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 6 12 2 16 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sunset",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 18a5 5 0 0 0-10 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 10.22,
    x2: 5.64,
    y2: 11.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 3,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 23,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 11.64,
    x2: 19.78,
    y2: 10.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 22,
    x2: 1,
    y2: 22
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 5 12 9 8 5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tablet",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 20,
    rx: 2,
    ry: 2,
    transform: "rotate(180 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 7
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "target",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "terminal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "4 17 10 11 4 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 20,
    y2: 19
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "thermometer",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "toggle-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 22,
    height: 14,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "toggle-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 22,
    height: 14,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trash-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 14,
    y2: 17
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trello",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 3,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 3,
    height: 5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trending-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "23 18 13.5 8.5 8.5 13.5 1 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 18 23 18 23 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trending-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "23 6 13.5 15.5 8.5 10.5 1 18"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 6 23 6 23 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "triangle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "truck",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 15,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 8 20 8 23 11 23 16 16 16 16 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 2.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tv",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 15,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 2 12 7 7 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "type",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "4 7 4 4 20 4 20 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "umbrella",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "underline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 21,
    x2: 20,
    y2: 21
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "unlock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 11,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 9.9-1"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "upload-cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 12 12 8 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 12 12 8 16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "upload",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 8 12 3 7 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 11 19 13 23 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user-x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 8,
    x2: 23,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 8,
    x2: 18,
    y2: 13
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "users",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "video-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "video",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23 7 16 12 23 17 23 7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 15,
    height: 14,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "voicemail",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 11.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 11.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 16,
    x2: 18.5,
    y2: 16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "volume-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 8.46a5 5 0 0 1 0 7.07"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "volume-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "volume-x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 9,
    x2: 17,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 9,
    x2: 23,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "volume",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "watch",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 9 12 12 13.5 13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "wifi-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.71 5.05A16 16 0 0 1 22.58 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "wifi",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12.55a11 11 0 0 1 14.08 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42 9a16 16 0 0 1 21.16 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "wind",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "x-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "x-octagon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "x-square",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 6,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 18,
    y2: 18
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "youtube",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "zap-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "12.41 6.75 13 2 10.57 4.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.57 12.91 21 10 15.66 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 8 3 14 12 14 11 22 16 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "zap",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "zoom-in",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 16.65,
    y2: 16.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 8,
    x2: 11,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 14,
    y2: 11
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "zoom-out",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 16.65,
    y2: 16.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 14,
    y2: 11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrhIconSprite);
export default __webpack_public_path__ + "static/media/prh-icon-sprite.eeec14fe2d1ea500008fc540d344e282.svg";
export { ForwardRef as ReactComponent };